<ng-container *ngIf="activeCart$|async as cart">
  <ng-container
    *ngIf="$any(cart)?.selectedOrderTypeCode == 'STOR' && ($any(cart).showCorePrice && $any(cart).showListPrice&&$any(cart).showNetPrice)">
    <div *ngIf="showTranslatedString" class="alert alert-warning ng-star-inserted">
      <span class="pl-3">{{translatedString}} </span>
      <button type="button" class="close">
        <cx-icon (click)="hidePromotions()" class="cx-icon fas fa-times" ng-reflect-type="CLOSE">
        </cx-icon>
      </button>
    </div>
  </ng-container>
  <div class="container cart-container">
    <div class="row mx-sm-3 d-small-none">
      <div class="col-xs-12 col-sm-8"> </div>
      <div class="col-xs-12 col-sm-4 save-cart-button">
        <a #element class="save-cart-btn" (click)="openDialog(cart)">{{'common.text_save_cart_title'|cxTranslate}}</a>
      </div>
    </div>
  </div>
  <div class="container cart-container">
    <div class="row mx-sm-3 cart-id">
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6 card-id-section">
        <div class="js-cart-top-totals cart__top--totals">
          <h1 class="cart-headline">
            <strong>{{'common.text_cart'|cxTranslate}}</strong>
            <span class="cart__id--label">
              {{'common.text_account_savedCart_id'|cxTranslate}}:
              <span class="cart__id"> {{$any(cart).code}}</span>
            </span>
          </h1>
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-6 col-lg-6"></div>
    </div>
    <div class="row mx-sm-3 d-lg-none">
      <div class="col-xs-12 col-sm-8"> </div>
      <div class="col-xs-12 col-sm-4 save-cart-button">
        <a #element class="save-cart-btn" (click)="openDialog(cart)">{{'common.text_save_cart_title'|cxTranslate}}</a>
      </div>
    </div>
    <!-- order section -->
    <div class="row order-section mt-2 mx-sm-3 ps-2 cart-order-section">
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-5">
        <div class="row">
          <label class="col-sm-12 col-md-12 col-lg-4 order-type">
            {{'common.cart_page_ordertypes'|cxTranslate}}</label>
          <div class="col-sm-12 col-md-12 col-lg-8 order-type-select">
            <select class="form-select" id="cart-order-type" (change)="onOrderTypeChange($event,$any(cart).code)">
              <option value="null" disabled>{{'common.cart_orderType_selection'|cxTranslate}}</option>
              <option [value]="item.key" [selected]="item.key==$any(cart).selectedOrderTypeCode"
                *ngFor="let item of $any(cart)?.orderType?.entry">{{item.value}}</option>
            </select>
          </div>
          <label class="order-type-error" *ngIf="showOrderTypeError">
            {{ "common.cart_select_order_type_errormsg" | cxTranslate }}
          </label>
        </div>
      </div>
      <div class="col-xs-12 col-sm-12 col-md-12 col-lg-7">
        <div class="row deliveryDate">
          <label for="deliveryDate" class="col-xs-12 col-sm-12 col-md-12 col-lg-7 text-md-end text-start text-end">
            {{'common.cart_page_req_delivery_date_for_all_items'|cxTranslate}}</label>
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-5 cart-top-date-div">
            <mat-form-field appearance="fill" style="width: 100%;" [ngClass]="vorMessage ? 'disabled-input' : '' ">
              <input matInput [matDatepicker]="picker1" [min]="$any(cart).defaultRDDFormatted"
                [disabled]="$any(cart).isDeliveryDateDisable" [matDatepickerFilter]="weekendsDatesFilter"
                [formControl]="deliveryDateControl" (blur)="rddValueChange(
                                        $any(cart).code,
                                        $event,
                                        -1,
                                        'blur',
                                        cart
                                    )" (dateChange)="
                                    rddValueChange(
                                    $any(cart).code,
                                    deliveryDateControl.value,
                                    -1,
                                    'change',
                                    cart
                                    )" readonly="{{readonly}}">
              <mat-datepicker-toggle matSuffix [for]="picker1" [ngClass]="vorMessage ? 'disabled-input' : '' ">
                <mat-icon matDatepickerToggleIcon>
                  <img src="/icons/calendar.png" alt="Calendar">
                </mat-icon>
              </mat-datepicker-toggle>
              <mat-datepicker #picker1></mat-datepicker>
            </mat-form-field>
            <!-- <span class="cart-date-error"></span> -->
          </div>
          <div class="col-xs-12 col-sm-12 col-md-12 col-lg-7">
          </div>

          <span class="error-msg col-xs-12 col-sm-12 col-md-12 col-lg-5 padding-0"
            *ngIf="isPastDate && !disableDate">{{'common.globle_notLessThanToday'|cxTranslate}}</span>
          <span class="error-msg col-xs-12 col-sm-12 col-md-12 col-lg-5 padding-0"
            *ngIf="isWeekendDate && !isPastDate">{{'common.globle_weekendDate'|cxTranslate}}</span>
          <span class="error-msg col-xs-12 col-sm-12 col-md-12 col-lg-5 padding-0"
            *ngIf="isInvalid">{{'common.globle_invalidDateFormat'|cxTranslate}}</span>

        </div>
      </div>
    </div>
    <!-- cart list item wrapper -->
    <div class="row cart-list-item-wrapper mx-sm-3">
      <div class="col-12 text-end mobile-delete-wrapper">
        <button [disabled]="selectedEntryNbr.length==0" (click)="deleteAll($any(cart).code)"
          class="cart-delete-selected">{{'common.general_delete_all_button'|cxTranslate}}</button>
        <div class="d-lg-none col-3 col-md-1 delete-checkbox-section">
          <span class="custom-checkbox">
            <input id="remove_cart-all-mobile" [checked]="selectAllChecked" (change)="selectAll($event)"
              name="removecartmobile" class="cart-checkbox" type="checkbox" value="">
            <label for="remove_cart-all"></label>
          </span>
        </div>
      </div>
      <div class="col-12 mt-2 cart-details-section">
        <div class="table-responsive">
          <table class="table table-bordered ">
            <thead>
              <tr class="d-none d-lg-table-row">
                <td class="product-image"></td>
                <td>{{'common.basket_cartpage_pos'|cxTranslate}}</td>
                <td>{{'common.text_quickOrder_page_part_no'|cxTranslate}}
                </td>
                <td>{{'common.cart_basket_typeNo'|cxTranslate}}</td>
                <td>{{'common.basket_cartpage_typeNo'|cxTranslate}}</td>
                <td>{{'common.basket_page_itemDescription'|cxTranslate}}</td>
                <td>{{'common.basket_page_weightPerKg'|cxTranslate}}</td>
                <td>{{'common.basket_page_qty'|cxTranslate}}</td>
                <td>{{'common.basket_page_deliveryDate'|cxTranslate}}</td>

                <td *ngIf="$any(cart).showCorePrice && fleetPrideGroup">
                  {{'common.basket_page_coredeposit'|cxTranslate}}
                  <br>({{$any(cart).totalPrice?.currencyIso}})
                </td>
                <td *ngIf="$any(cart).showNetPrice && fleetPrideGroup">
                  {{'common.basket_page_customerPrice'|cxTranslate}}
                  <br>({{$any(cart).totalPrice?.currencyIso}})
                </td>
                <td *ngIf="fleetPrideGroup && $any(cart).showNetPrice" class="total-price-column">
                  {{'common.basket_page_totals_total'|cxTranslate}}
                  <br>({{$any(cart).totalPrice?.currencyIso}})
                </td>
                <td class="select-all-check">
                  <span class="custom-checkbox">
                    <input id="remove_cart-all" [checked]="selectAllChecked" (change)="selectAll($event)"
                      name="removecart" class="cart-checkbox" type="checkbox" value="">
                    <label for="remove_cart-all"></label>
                  </span>
                </td>
              </tr>
            </thead>
            <tbody class="table-content w-100">
              <ng-container>
                <tr class="cart-for-mobile" *ngFor="let item  of cartDetails;let i=index">
                  <td class="logo">
                    <a [routerLink]="{cxRoute:'product',params:item.product}|cxUrl" tabindex="0">
                      <cx-media style="height: 88px;"
                        [container]="item.product?.images?.['PRIMARY'] || item.product?.images"></cx-media>
                    </a>
                  </td>
                  <td class="pos">{{(item.entryNumber*10)+10}}</td>
                  <td class="product-code">
                    <a [routerLink]="{cxRoute:'product',params:item.product}|cxUrl">{{item.product['code']}}</a>
                  </td>
                  <td class="part-no">{{item.product['typenumber']}}</td>
                  <td class="weight">{{item['customPartNumber']}}</td>
                  <td class="customer-part-no">{{item.product?.description}}</td>

                  <td class="weight">
                    <span class="d-lg-none weight-mobile">{{'common.text_weight'|cxTranslate}} (KG)
                    </span>
                    {{item.quantity*item.product['netWeight']| number : '1.2-2'}}
                  </td>
                  <td class="qty">
                    <div>
                      <span class="d-lg-none">{{'common.basket_page_qty'|cxTranslate}}</span>
                      <span>
                        <input #txtInput type="number" name="quantity" min="0" oninput="validity.valid||(value='');"
                          (keydown.enter)="quantityUpdate(item.quantity, item.entryNumber, item, $any(cart).code)"
                          (blur)="quantityUpdate(item.quantity, item.entryNumber, item, $any(cart).code)"
                          class="form-control text-center border cart-quantity-input" [(ngModel)]="item.quantity">

                      </span>
                    </div>
                  </td>
                  <td class="rdd">
                    <div class="item_delivery-datepicker">
                      <span class="d-lg-none w-60">{{'common.basket_page_deliveryDate'|cxTranslate}}</span>
                      <mat-form-field appearance="fill">
                        <input matInput class="date-picker" [matDatepicker]="picker"
                          [min]="$any(cart).defaultRDDFormatted" [disabled]="$any(cart).isDeliveryDateDisable"
                          [matDatepickerFilter]="weekendsDatesFilter" (blur)="rddValueChangeLineItem(
                                                            $any(cart).code,
                                                            $event,
                                                            $any(item).entryNumber,
                                                            'blur',
                                                            i,
                                                            $any(cart)
                                                            )" (dateChange)="
                                                            rddValueChangeLineItem(
                                                                $any(cart).code,
                                                                $any(item).requestedDeliveryDateFormatted,
                                                                $any(item).entryNumber,
                                                                'change',
                                                                i,
                                                            $any(cart)
                                                            )
                                                            " [(ngModel)]="$any(item).requestedDeliveryDateFormatted">
                        <mat-datepicker-toggle matSuffix [for]="picker">
                          <mat-icon matDatepickerToggleIcon>
                            <img src="/icons/calendar.png" alt="Calendar" style="height: 20px; width: 20px;">
                          </mat-icon>
                        </mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    </div>
                    <span class="error-msg col-xs-12 col-sm-12 col-md-12 col-lg-5 padding-0"
                      *ngIf="item.isWeekendDate && !item.isPastDate">{{'common.globle_weekendDate'|cxTranslate}}</span>
                    <span class="error-msg col-xs-12 col-sm-12 col-md-12 col-lg-5 padding-0"
                      *ngIf="item.isInvalid">{{'common.globle_invalidDateFormat'|cxTranslate}}</span>

                  </td>

                  <td class="customer-price" *ngIf="$any(cart).showCorePrice&& fleetPrideGroup">
                    <span class="d-lg-none">{{'common.basket_page_coredeposit'|cxTranslate}}:</span>
                    <div *ngIf="$any(item)?.surcharge?.formattedValue 
                                                    && $any(item)?.surcharge?.formattedValue.indexOf('-') < 0">
                      {{ $any(item)?.surcharge?.formattedValue }}
                    </div>
                    <div *ngIf="!$any(item)?.surcharge 
                                                ||  $any(item)?.surcharge?.formattedValue.indexOf('-') > -1">
                      {{ 'common.basket_page_poa' | cxTranslate }}
                    </div>

                  </td>
                  <td class="customer-price" *ngIf="$any(cart).showNetPrice&& fleetPrideGroup">
                    <span class="d-lg-none">{{'common.basket_page_customerPrice'|cxTranslate}}:</span>

                    <div *ngIf="$any(item)?.basePrice?.formattedValue 
                                                    && $any(item)?.basePrice?.formattedValue.indexOf('-') < 0">
                      {{ $any(item)?.basePrice?.formattedValue }}
                    </div>
                    <div *ngIf="!$any(item)?.basePrice 
                                                ||  $any(item)?.basePrice?.formattedValue.indexOf('-') > -1">
                      {{ 'common.basket_page_poa' | cxTranslate }}
                    </div>
                  </td>
                  <td *ngIf="$any(cart).showNetPrice && fleetPrideGroup" class="total">
                    <span class="d-lg-none">{{'common.text_quickOrder_page_total'|cxTranslate}}:</span>
                    <div *ngIf="$any(item)?.totalPrice && $any(item)?.totalPrice?.formattedValue.indexOf('-')<0">
                      {{$any(item)?.totalPrice?.formattedValue}}</div>
                    <div *ngIf="!($any(item)?.totalPrice) ||$any(item)?.totalPrice?.formattedValue.indexOf('-')>-1">
                      {{'common.basket_page_poa'|cxTranslate}}</div>
                  </td>
                  <td class="remove-checkbox">
                    <div class="d-flex align-items-center remove-mobile">
                      <span class="custom-checkbox">

                        <span class="custom-checkbox">
                          <input [checked]="$any(item).selected" (change)="setSelect($event, item, i)"
                            class="cart-remove-checkbox" type="checkbox" id="remove_cart-line-item{{i}}" />
                          <label for="remove_cart-line-item{{i}}"></label>
                        </span>

                      </span>
                      <span (click)="deleteLineItem(item, $any(cart).code,item)" class="remove-item"></span>
                    </div>
                  </td>
                </tr>

              </ng-container>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- checkout section -->
    <div class="cart-page-wrapper mx-sm-3">
      <div class="row">
        <div class="col-xs-12 col-md-12 col-lg-7 cart-weight-block d-none d-lg-block">
          <div *ngIf="$any(cart).totalWeight?.toFixed(2)">
            <div class="total-weight-cart"></div>
            <div class="total-weight-section">
              <span [innerHTML]=""></span>{{$any(cart).totalWeight?.toFixed(2)}} &nbsp;Kg <br>
              {{'common.basket_page_totalWeight'|cxTranslate}}
            </div>
          </div>
        </div>

        <div *ngIf="$any(cart).totalWeight?.toFixed(2)" class="col-xs-12 col-md-12 d-lg-none">
          <div class="row">
            <div class="col-6 text-start cart-totals-left">{{'common.basket_page_totalWeight'|cxTranslate}}
            </div>
            <div class="col-6 text-end cart-totals-right">
              {{$any(cart).totalWeight?.toFixed(2)}} &nbsp;Kg <br>
            </div>
          </div>
        </div>

        <div class="col-xs-12 col-md-12 col-lg-5">
          <div class="row cart-totals" *ngIf="$any(cart).showNetPrice && fleetPrideGroup">
            <div class="col-6 cart-totals-left">{{'common.basket_page_totals_subtotal'|cxTranslate}}</div>

            <div class="col-6 cart-totals-right text-end" *ngIf="
            $any(cart)?.subTotal?.formattedValue.indexOf('-') > -1 ;else showSubTotalPrice
            ">
              {{ 'common.basket_page_poa' | cxTranslate }}
            </div>
            <ng-template #showSubTotalPrice>
              <div class="col-6 cart-totals-right text-end">
                {{ $any(cart).subTotal?.formattedValue }}
                {{ $any(cart).subTotal?.currencyIso }}
              </div>
            </ng-template>
          </div>

        </div>
      </div>
      <div class="row mt-2">
        <div class="col-sm-6 col-lg-7">
          <div class="poa-cartpage" *ngIf="fleetPrideGroup && $any(cart)?.showPOAText && $any(cart).showNetPrice">

            <span [innerHTML]="'common.cart_total_poa_NA'|cxTranslate"></span>
          </div>
        </div>
        <div class="col-sm-12 col-lg-5 checkout-shopping-cart-block">

          <div class="row mobile-cart-buttons">
            <div class="col-6 continue-cart-btn p-1">
              <button class="btn btn--continue-shopping" [routerLink]="{ cxRoute: '/' } | cxUrl"
                data-continue-shopping-url="/US/en/USD/search/?text=000">
                {{'common.cart_page_continue'|cxTranslate}}</button>
            </div>
            <div class="col-6 p-1">
              <button [disabled]="isFormError" [ngClass]="{'btn-disabled':isFormError}"
                class="btn btn--continue-checkout"
                (click)="canNavigateCheckout($any(cart)?.code, $any(cart).selectedOrderTypeCode)">
                {{'common.cart_page_checkout'|cxTranslate}}
                <i class="icon icon--link checkout-btn-icon" aria-hidden="true"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>